import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/car/printform',
  title: '打印申请表',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
